import React, {useCallback} from 'react';
import { Trans } from 'react-i18next';
import classes from './EndChatModal.module.scss';
import Modal from '../Modal/Modal';
import { setEndChatIsOpen } from '../../store/actions/general';
import { useDispatch } from 'react-redux';

const EndChatModal = ({isOpen, closeHandler, socket}) => {
    const dispatch = useDispatch();
    const endChat = useCallback(() => {
        socket.emit("end-chat", {});
        dispatch(setEndChatIsOpen(false));
      }, [socket, dispatch]);
    return (
        <Modal isOpen={isOpen} onClose={closeHandler} contentWidth={'60%'}>
            <div className={classes.EndChatModalContainer}>
                <h2 style={window.sutherland_variables.ui.end_chat_styles.title}>
                    <Trans i18nKey="endChat.title">End chat</Trans>
                </h2>
                <div className={classes.EndChatModalContent}>
                    <div className={classes.Label} style={window.sutherland_variables.ui.end_chat_styles.content}>
                        <Trans i18nKey="endChat.content">Are you sure you want to end this chat session?</Trans>
                    </div>
                    <div className={classes.Buttons}>
                        <button className={classes.ButtonEnd} onClick={endChat}  
                         style={window.sutherland_variables.ui.end_chat_styles.button} 
                         onMouseEnter={(e) => Object.assign(e.target.style, window.sutherland_variables.ui.end_chat_styles.button_hover)}
                         onMouseLeave={(e) => Object.assign(e.target.style, window.sutherland_variables.ui.end_chat_styles.button)}
                        >
                            <Trans i18nKey="endChat.button">End Chat</Trans>
                        </button>
                    </div>
                    <div className={classes.ButtonCancel}>
                        <button onClick={closeHandler} style={window.sutherland_variables.ui.end_chat_styles.cancel_button}>
                            <Trans i18nKey="endChat.cancel">Cancel</Trans>
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default EndChatModal;
